var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconIpr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "wasm-icon-stroke",
    x: 12.52,
    y: 12.52,
    width: 38.95,
    height: 38.95,
    transform: "translate(32 -13.25) rotate(45)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "5.56px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconIpr);
export default __webpack_public_path__ + "static/media/SDS_icon_IPR.35abcb5aa8f2f7534bdbd631eaf1d474.svg";
export { ForwardRef as ReactComponent };